import { useId } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export function VerificationConfirmation({
  ready,
  skippedCount,
  confirmed,
  onConfirmedChange,
  pending,
  starting,
  onStart,
  onCancel,
}: {
  ready: boolean;
  skippedCount: number;
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
  pending: boolean;
  starting: boolean;
  onStart: () => void;
  onCancel: () => void;
}) {
  const confirmationId = useId();
  return (
    <section
      className="space-y-3 border-t pt-4"
      aria-label="Confirm verification details"
    >
      <p className="text-xs leading-5 text-muted-foreground">
        The run checks applicable licensing boards, the NPI registry, saved DEA
        registrations, Medicare opt-out, federal exclusions, supported state
        Medicaid exclusions, and OFAC sanctions. Unsupported licenses require
        manual verification.
      </p>
      {skippedCount > 0 && (
        <p className="text-xs font-medium">
          {skippedCount} saved state{" "}
          {skippedCount === 1 ? "license" : "licenses"} skipped for this run.
        </p>
      )}
      <div className="flex items-start gap-2 rounded-xl border p-3">
        <Checkbox
          id={confirmationId}
          checked={confirmed}
          disabled={pending || !ready}
          onCheckedChange={(value) => onConfirmedChange(value === true)}
        />
        <Label
          htmlFor={confirmationId}
          className="cursor-pointer text-sm leading-5"
        >
          I confirm this NPI belongs to this provider and the state license
          details above are accurate.
        </Label>
      </div>
      {!ready && (
        <p className="text-xs text-muted-foreground">
          Confirm the provider’s NPI and complete every license’s state and
          number before starting.
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          disabled={!ready || !confirmed || pending}
          onClick={onStart}
        >
          {starting ? "Starting verification…" : "Start verification"}
        </Button>
        <Button
          type="button"
          variant="ghost"
          disabled={pending}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </section>
  );
}
